﻿import LandingPage from "./Registration/LandingPage.svelte";
import PersonalDetails from "./Registration/PersonalDetails.svelte";
import DocumentUpload from "./Registration/DocumentMultiUpload.svelte";
import ClaimDetails from "./Registration/ClaimDetails.svelte";

const confirmationPages = [
	{
		component: LandingPage,
		routeId: "/Registration",
		confirmationHeading: null
	},
	{
		component: PersonalDetails,
		routeId: "/Registration/PersonalDetails",
		confirmationHeading: "Your details"
	},
	{
		component: ClaimDetails,
		routeId: "/Registration/ClaimDetails",
		confirmationHeading: "Claim Details"
	},
	{
		component: DocumentUpload,
		routeId: "/Registration/DocumentUpload",
		confirmationHeading: "Document Upload"
	}
];

export default confirmationPages;
